import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';

import delButton from './img/del.png';
import './styles.scss';

class FormYearsRow extends Component {
  constructor () {
    super();
    this.state = {
    };
  }
  componentDidMount() {
  }

  minChange = (e) => {
    this.props.changeField(this.props.id, Number(e.value), this.props.data.maxValue);
  }
  maxChange = (e) => {
    this.props.changeField(this.props.id, this.props.data.minValue, Number(e.value));
  }
  delRow = () => {
    this.props.delRow(this.props.id);
  }
  leaseTermChange = (e) => {
    this.props.changeLeaseTerm(e, this.props.id);
  }
  render() {
    const fromOptions = () => {
      const body = [];
      for (
        let i = Number(this.props.data.minValueSel);
        i <= Number(this.props.data.maxValue);
        // eslint-disable-next-line
        i++) {
        body.push({
          value: i,
          label: i
        });
      }
      return body;
    };
    const toOptions = () => {
      const body = [];
      for (
        let i = Number(this.props.data.minValue);
        i <= Number(this.props.data.maxValueSel);
        // eslint-disable-next-line
        i++) {
        body.push({
          value: i,
          label: i
        });
      }
      return body;
    };
    const leaseOptions = () => {
      const body = [];
      for (
        let i = Number(this.props.data.minLeaseTerm);
        i <= Number(this.props.data.maxLeaseTerm);
        // eslint-disable-next-line
        i++) {
        body.push({
          value: i,
          label: i * 12
        });
      }
      return body;
    };
    return (
      <div className="body-FormYear">
        <div className="inputYear-body-FormYear" >
          <div>Form</div>
          <Select
            className="from-FormYear"
            name="from"
            value={this.props.data.minValue}
            onChange={this.minChange}
            options={fromOptions()}
            clearable={false}
            searchable={false}
            menuBuffer={10}
            disabled={this.props.data.positionMin === true}
          />
          <div>to</div>
          <Select
            className="from-FormYear"
            name="to"
            value={this.props.data.maxValue}
            onChange={this.maxChange}
            options={toOptions()}
            clearable={false}
            searchable={false}
            menuBuffer={10}
            disabled={this.props.data.positionMax === true}
          />
          <div>years</div>
        </div>
        <div className="months-body-FormYear">
          <Select
            className="from-FormYear"
            name="lease"
            onChange={this.leaseTermChange}
            value={this.props.data.selectLeaseTerm}
            options={leaseOptions()}
            clearable={false}
            searchable={false}
            menuBuffer={10}
          />
          <div>{`months (
            ${this.props.data.selectLeaseTerm}
            years)`}
          </div>
          {
            this.props.id === 0 ?
            '' :
            <button onClick={this.delRow}>
              <img src={delButton} alt="delButton_pic" />
            </button>
          }
        </div>
      </div>
    );
  }
}

FormYearsRow.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  changeLeaseTerm: PropTypes.func.isRequired,
  changeField: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  delRow: PropTypes.func.isRequired
};


export default FormYearsRow;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/Settings/components/FormYearsRow/index.js